module.exports = __webpack_public_path__ + "img/tutorial_pc_background.3f40fe75.png";